// Rails gemmer telefonnumre normaliseret uden "+" (fx "4512345678").
const COUNTRY_CODES = {DK: '45', NO: '47', SE: '46'}

export function formatPhone (phone) {
  if (!phone) {
    return ''
  }
  const digits = String(phone).replace(/\D/g, '')
  const code = Object.keys(COUNTRY_CODES)
    .map(key => COUNTRY_CODES[key])
    .find(prefix => digits.indexOf(prefix) === 0 && digits.length === prefix.length + 8)
  if (!code) {
    return phone
  }
  const local = digits.slice(code.length)
  return '+' + code + ' ' + local.replace(/(\d{2})(?=\d)/g, '$1 ')
}

// Svarer til User#phone_humanized= for de almindelige tilfælde: et 8-cifret
// nummer uden landekode får skolens landekode foran.
export function normalizePhone (value, country) {
  if (!value || !String(value).trim()) {
    return null
  }
  const digits = String(value).replace(/\D/g, '')
  const code = COUNTRY_CODES[(country || '').toUpperCase()]
  if (code && digits.length === 8) {
    return code + digits
  }
  return digits
}



// WEBPACK FOOTER //
// ./src/components/SchoolUsers/phone.js